// extracted by mini-css-extract-plugin
export default {"list":"_2BrDZ","item":"ZCyc1","iconContainer":"_3dvza","link":"_2er7P","linkSelected":"GUZI7"};